export function isPetitionTooOld(createdAt: string, createdAfter: string) {
	return createdAt < createdAfter;
}
